var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0.5C6.82292 0.5 6.88021 0.526042 6.92188 0.578125C6.97396 0.619792 7 0.677083 7 0.75V1.25C7 1.32292 6.97396 1.38542 6.92188 1.4375C6.88021 1.47917 6.82292 1.5 6.75 1.5H0.25C0.177083 1.5 0.114583 1.47917 0.0625 1.4375C0.0208333 1.38542 0 1.32292 0 1.25V0.75C0 0.677083 0.0208333 0.619792 0.0625 0.578125C0.114583 0.526042 0.177083 0.5 0.25 0.5H2.125L2.26562 0.203125C2.33854 0.0677083 2.45312 0 2.60938 0H4.39062C4.54688 0 4.66146 0.0677083 4.73438 0.203125L4.875 0.5H6.75ZM0.828125 7.29688L0.5 2H6.5L6.17188 7.29688C6.16146 7.49479 6.08333 7.66146 5.9375 7.79688C5.79167 7.93229 5.61979 8 5.42188 8H1.57812C1.38021 8 1.20833 7.93229 1.0625 7.79688C0.916667 7.66146 0.838542 7.49479 0.828125 7.29688Z",
    fill: "#C6C6C6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.6678df84.svg";
export { ForwardRef as ReactComponent };